import {
  deleteContractSublocation,
  clearContractSublocationAction,
} from 'actions/contracts/contractSublocationActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractSublocationDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractSublocationAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractSublocation(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract sublocation? This can not
        be undone.
      </div>
    </form>
  )
}

export default ContractSublocationDelete
